export enum TopsortIds {
  BANNER_HOME_1 = 'banner_home_1',
  BANNER_HOME_2 = 'banner_home_2',
  BANNER_HOME_3 = 'banner_home_3',
  BANNER_POS_CHECKOUT_1 = 'banner_pos_checkout_1',
  BANNER_POS_CHECKOUT_2 = 'banner_pos_checkout_2',
  BANNER_RECLAME_AQUI = 'banner_reclame_aqui'
}
